module.exports = __webpack_public_path__ + "img/couples-082.4a888d82.jpg";